import {
  Box,
  Button,
  makeStyles,
  ThemeProvider,
  Typography,
} from "@material-ui/core";
import { useTranslate } from "ra-core";
import React from "react";
import { useHistory } from "react-router-dom";
import CorrectLogo from "../../assets/correct.png";
import theme from "../../theme";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.lightGray2,
    borderColor: "transparent",
    display: "grid",
    placeItems: "center",
    justifyContent: "center",
  },
  container: {
    marginTop: 150,
  },
  textStyle: {
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: 32,
    textAlign: "center",
    marginTop: 20,
  },
  secondTextStyle: {
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: 32,
    textAlign: "center",
  },
  button: {
    width: 352,
    height: 49,
    borderRadius: 8,
    backgroundColor: theme.orange,
    color: theme.white,
    marginBottom: 200,
  },
  logoContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
}));
function ResetPasswordSuccessPage() {
  const history = useHistory();
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <ThemeProvider theme={theme}>
      <Box className={classes.allContainer}>
        <Box className={classes.container}>
          <Box className={classes.logoContainer}>
            <img src={CorrectLogo} alt="" />
          </Box>

          <Typography className={classes.textStyle}>
            {translate("ra.text.forgotPassword.congratulation")}
          </Typography>
          <Typography className={classes.secondTextStyle}>
            {translate("ra.text.forgotPassword.passwordChanged")}
          </Typography>
        </Box>
        <Button
          variant="contained"
          classes={{ contained: classes.button }}
          onClick={() => history.push({ pathname: "/login" })}
        >
          {translate("ra.text.forgotPassword.goToSignIn")}
        </Button>
      </Box>
    </ThemeProvider>
  );
}

export default ResetPasswordSuccessPage;
